import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { TrendTypes } from '@dataTypes/dashboard.types'

import arrowUp from '@assets/images/Dashboard/arrow-up.png'
import arrowDown from '@assets/images/Dashboard/arrow-down.png'
import { formatNumber } from '@utils/index'

type DisplayCard = {
  displayText: number
  trendDirection: TrendTypes
  showCurrencySymbol: boolean
}

function DisplayCard({
  displayText,
  trendDirection,
  showCurrencySymbol,
}: DisplayCard): React.ReactElement {
  return (
    <Row>
      <Col md={6}>
        <div className={`display-6 fw-bolder text-black`}>
          {formatNumber(displayText, showCurrencySymbol)}
        </div>
      </Col>
      <Col md={6} className="text-end">
        <img
          src={`${trendDirection === 'increase' ? arrowUp : arrowDown}`}
          height={45}
          alt="Arrow icon"
        ></img>
      </Col>
    </Row>
  )
}

export default DisplayCard
